import React from 'react';
import styled, { css } from 'styled-components';
import RepresentationString from '../../../RepresentationString';
import JustificationContainer from '~/components/atom/JustificationContainer';
import type { FlowV2_ConditionListFragment } from '~/graphql/types';
import type { IBuilderContext } from '../../../Builder/context';
import BuilderContext from '../../../Builder/context';

const TriggerColumn: React.FC<{
  iBuilderContext: IBuilderContext;
  actionId: string;
  conditionList?: FlowV2_ConditionListFragment;
}> = ({ iBuilderContext, conditionList, actionId }) => {
  if (!conditionList) return <>Geen condities</>;

  if (!conditionList.conditions[0]) return <>Geen condities</>;

  return (
    <BuilderContext.Provider value={iBuilderContext}>
      <JustificationContainer direction="column">
        <StyledRepresentationString
          key={conditionList.conditions[0].id}
          condition={conditionList.conditions[0]}
          actionId={actionId}
          hasIssue={false}
        />
      </JustificationContainer>
    </BuilderContext.Provider>
  );
};

const StyledRepresentationString = styled(RepresentationString)(
  ({ theme }) => css`
    font-weight: ${theme.fw('regular')};
  `,
);

export default TriggerColumn;
